import { memoize } from 'proxy-memoize';
import { DocumentResultErrorTypes } from '@shared/types/DocumentResultError';
const getResultRowsIndexesWithErrorsMemo = memoize((errors) => {
    return errors.map(error => error.type === DocumentResultErrorTypes.error && error.index);
});
export const getResultRowsIndexesWithErrors = ({ errors }) => {
    return getResultRowsIndexesWithErrorsMemo(errors);
};
